import React from 'react';

export function CheckboxOff(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 0.799999H5.99999C3.12811 0.799999 0.799988 3.12812 0.799988 6V18C0.799988 20.8719 3.12811 23.2 5.99999 23.2H18C20.8719 23.2 23.2 20.8719 23.2 18V6C23.2 3.12812 20.8719 0.799999 18 0.799999ZM5.99999 3.2H18C19.5464 3.2 20.8 4.4536 20.8 6V18C20.8 19.5464 19.5464 20.8 18 20.8H5.99999C4.45359 20.8 3.19999 19.5464 3.19999 18V6C3.19999 4.4536 4.45359 3.2 5.99999 3.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
